"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The UpdateKeyTakeAwayModel model module.
 * @module model/UpdateKeyTakeAwayModel
 * @version 1.1.3-alpha.1
 */
class UpdateKeyTakeAwayModel {
  /**
   * Constructs a new <code>UpdateKeyTakeAwayModel</code>.
   * @alias module:model/UpdateKeyTakeAwayModel
   * @param caption {String} 
   */
  constructor(caption) {
    UpdateKeyTakeAwayModel.initialize(this, caption);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, caption) {
    obj['caption'] = caption;
  }

  /**
   * Constructs a <code>UpdateKeyTakeAwayModel</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UpdateKeyTakeAwayModel} obj Optional instance to populate.
   * @return {module:model/UpdateKeyTakeAwayModel} The populated <code>UpdateKeyTakeAwayModel</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UpdateKeyTakeAwayModel();
      if (data.hasOwnProperty('caption')) {
        obj['caption'] = _ApiClient.default.convertToType(data['caption'], 'String');
      }
      if (data.hasOwnProperty('timeout')) {
        obj['timeout'] = _ApiClient.default.convertToType(data['timeout'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>UpdateKeyTakeAwayModel</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UpdateKeyTakeAwayModel</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of UpdateKeyTakeAwayModel.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['caption'] && !(typeof data['caption'] === 'string' || data['caption'] instanceof String)) {
      throw new Error("Expected the field `caption` to be a primitive type in the JSON string but got " + data['caption']);
    }
    return true;
  }
}
UpdateKeyTakeAwayModel.RequiredProperties = ["caption"];

/**
 * @member {String} caption
 */
UpdateKeyTakeAwayModel.prototype['caption'] = undefined;

/**
 * @member {Number} timeout
 */
UpdateKeyTakeAwayModel.prototype['timeout'] = undefined;
var _default = UpdateKeyTakeAwayModel;
exports.default = _default;